import * as React from 'react';
import { useContext } from 'react';
import { getIdVerificationStatus } from '../../../../../api/ProspectUserProfile';
import { useFetch } from '../../../../../hooks/useFetch';
import { browserHistory } from '../../../../../utilities/history';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';
import { PropertyContext, TourPage, tourSignupPath } from '../TourRouter';
import { ConfirmationSection } from './ConfirmationSection';

interface Props {
    guestCardGuid: string;
}

const IdVerificationConfirmationSection = (props: Props) => {
    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const { data, error, loading } = useFetch(
        () => getIdVerificationStatus(property.idVerificationType),
        [],
        undefined,
        property.idVerificationType !== undefined && property.idVerificationType !== null
    );

    const errorMessage = React.useMemo(() => {
        return error
            ? error
            : data
                ? data.idExpired
                    ? 'ID expired'
                    : !data.idVerified
                        ? 'ID verification incomplete'
                        : undefined
                : undefined;
    }, [data]);

    let body: React.ReactNode = loading ? (
        <LoadingDisplay />
    ) : !data || errorMessage ? (
        <FormValidationDisplay errorMessage={errorMessage} />
    ) : null;

    return (
        <ConfirmationSection
            headerText="ID Verification"
            hasIssue={!loading && !!(!data || error || !data.idVerified || data.idExpired)}
            onEditClick={() =>
                browserHistory.push(
                    tourSignupPath(property.slug, props.guestCardGuid)(TourPage.IdVerification)
                )
            }
        >
            {body}
        </ConfirmationSection>
    );
};

export default IdVerificationConfirmationSection;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/IdVerificationConfirmationSection.tsx